module.exports = __webpack_public_path__ + "img/code_blocks.eef25b9f.svg";